module.exports = __webpack_public_path__ + "img/collaterals-download.9e982a52.jpg";